// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item {
  height: 100px;
  display: flex;
  width: 100%;
}

.row {
  height: 100px;
  display: flex;
  width: 100%;
}

.time-picker {
  --backdrop-opacity: 0.5 !important;
}

.footer {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  margin-left: 15px;
  width: 95%;
}`, "",{"version":3,"sources":["webpack://./src/app/elenco-presenti/inserisci-conferma/inserisci-conferma.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,aAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,aAAA;EACA,WAAA;AACJ;;AAEA;EACI,kCAAA;AACJ;;AAEA;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;AACJ","sourcesContent":[".item {\n    height: 100px;\n    display: flex;\n    width: 100%;\n}\n\n.row {\n    height: 100px;\n    display: flex;\n    width: 100%;\n}\n\n.time-picker {\n    --backdrop-opacity: 0.5 !important;\n}\n\n.footer {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 15px;\n    margin-left: 15px;\n    width: 95%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
